import { useState } from "react";
import type { FormEvent } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/emc/Field";
import { ErrorState } from "@/components/emc/states";
import { useAuth } from "@/lib/auth";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email, password);
    } catch (caught: unknown) {
      setError(caught instanceof Error ? caught.message : "Nem sikerült a belépés.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="grid min-h-screen place-items-center px-4 py-10">
      <Card className="w-full max-w-narrow gap-5 py-6">
        <CardHeader className="px-6">
          <h1>Belépés</h1>
        </CardHeader>
        <CardContent className="px-6">
          <form className="flex flex-col gap-4" onSubmit={onSubmit}>
            {error !== null && <ErrorState message={error} />}
            <Field label="Email" htmlFor="email">
              <Input
                id="email"
                type="email"
                autoComplete="username"
                required
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </Field>
            <Field label="Jelszó" htmlFor="password">
              <Input
                id="password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </Field>
            <Button className="mt-1 w-full" type="submit" disabled={busy}>
              {busy ? "Belépés…" : "Belépés"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
